import React, { Component, Fragment } from "react";
import ReactFilestack from "react-filestack";
import { AppConfig, HttpResponse } from "../../../../core";
import { CustomerLogoService } from "./services/customer.logo.service";
import {
  FileUploadResponseModel,
  FileUploadModel,
} from "../../../../shared/models";
import { ShowSuccessMessage } from "../../../../shared/helpers";
import { Loader } from "../../../../shared/loaders";
import { ButtonType } from "../../../../shared/enums";
import { Link, Route } from "react-router-dom";
import Profile from "./Profile"


export class CustomerLogoForm extends Component<any> {
  private service: CustomerLogoService;
  constructor(props) {
    super(props);
    this.service = new CustomerLogoService();    
  }   

  onSuccessFileUpload(response) {
    if (response.filesUploaded[0].handle) {      
      let url = AppConfig.FilePickerUrl + response.filesUploaded[0].handle;
      let filedataata: FileUploadModel = {
        url: url        
      };
      this.postFile(filedataata);
    }
  }

  postFile(filedatata: FileUploadModel) {      
    this.service
      .postCustomerLogo(filedatata)
      .then((res: HttpResponse<FileUploadResponseModel>) => {
        if (res && res.result) {
          if (res.result.id > 0) {
            ShowSuccessMessage("File Uploaded successfully.");
            this.props.history.push("/customer-logo/detail/"+res.result.id);            
          }
        }
      });
  }
  

  render() {
    const storageOpts = {
      storeTo: {
        "location":"S3",
        "container":"staq-assets",
        "path":"app-logos/",
        "region":"us-east-1"
      }
    }

    return (
      <Fragment>
        <div className="d-flex justify-content-between align-items-center mb-3"></div>
        <div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>New Customer Logo</h4>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Upload New Customer Logo</label>{" "}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Profile th={this} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-3 mb-4">            
              <Fragment>
                <Link
                  type="button"
                  className="btn btn-lg btn-default"
                  to="/customer-Logo/list"
                >
                  {ButtonType.Cancel}
                </Link>
              </Fragment>            
          </div>
        </div>
      </Fragment>
    );
  }
}
